<template>
  <div class="full-height">
    <q-card-section id="scroll-table" class="q-pb-lg card-table">
    <jt-data-table
      v-if="nmInterface && !slots.table"
      ref="table"
      class="jt-datatable no-shadow table_header contract_table"
      :forms="forms"
      :buttons="datatable.buttons"
      :fields="datatable.columns"
      :nm-interface="nmInterface"
      :multiselect="true"
      selection-force
      :extraParams="extraParams"
      :is-paginated="false"
      @selection="onSelectionChange"
      @action-button="actionButton"
    />
    <br>
    <div>
      <span> {{ $gettext("TOTAL_GENERATE") }}:&nbsp;</span>
      <span class="formatedValue">R$ {{ total }}</span>
    </div>
    <fixed-order-page-detail
      v-if="detailModal.show"
      ref="detailModal"
      :show="detailModal.show"
      v-bind="detailModal"
      @input="(show) => (detailModal.show = show)"
      @action-button="actionButtonUpdate"
    />

    <modal
      v-if="generateModal.show"
      ref="generateOrderModal"
      :show="generateModal.show"
      v-bind="generateModal"
      @input="(show) => (generateModal.show = show)"
      @action-button="generateOrders"
    />
    </q-card-section>
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import FixedOrderPageDetail from './FixedOrderPageDetail.vue'
import { JtDataTable, JtCrud } from 'jtech-webcomps'
const { pageTable, modal } = JtCrud
import { repository } from 'jtech'
import { messageBox } from 'src/jtech'
import GenerateOrderState from '../GenerateOrderState'
import calculateTotalValue from './CalculateTotalValue.js'

@Component({
  name: 'GeneratorFixedOrder',
  components: {
    JtDataTable, FixedOrderPageDetail, modal
  },
  props: {
    itemsSelection: Array,
    params: Object,
    searchType: {
      type: String,
      default: 'fixed',
      required: false,
      validator: (value) => {
        const validTypes = ['fixed', 'contractMaintenance']
        return validTypes.includes(value)
      }
    }
  },
  mixins: [
    pageTable
  ]
})
class GeneratorFixedOrder extends Vue {
  filters = {
    fixed: {
      contractBillingType: 20560002
    },
    contractMaintenance: {
      contractBillingType: 20560003
    }
  }

  orderState = GenerateOrderState.getInstance();
  total = '0,00'
  extraParams = {}
  nmInterface = 'preFixedBillingOrder.pesquisar'
  datatable = null
  rowsSelected = []
  refs = {}
  detailModal = {
    show: false,
    detail: false
  }

  generateModal = {
    show: false
  }

  onSelectionChange (items) {
    this.rowsSelected = items
  }

  async mounted () {
    this.setBillingTypeFilters()
    this.extraParams = { ...this.extraParams, controlBatch: this.orderState.actualBatchInfos.id }
    this.datatable = await repository.resolveDatatable(this.nmInterface, this.extraParams)
  }

  setBillingTypeFilters () {
    if (this.searchType === 'contractMaintenance') {
      this.extraParams.contractBillingType = this.filters.contractMaintenance.contractBillingType
    } else {
      this.extraParams.contractBillingType = this.filters.fixed.contractBillingType
    }
  }

  @Watch('refs._data.serverData')
  calcTotalValue (newValue, oldValue) {
    this.$emit('on-change-table-data', newValue?.length)
    this.total = newValue.map(e => e.value)
    if (this.total.length != 0) {
      this.total = calculateTotalValue.calculate(newValue.map(e => e.value))
    } else {
      this.total = '0,00'
    }
  }

  updated () {
    if (this?.$refs?.jtDataTable?.$refs?.tableRef?._data) {
      this.refs = this.$refs.jtDataTable.$refs.tableRef
    }
  }

  async actionButton (button, params) {
    if (button.name === 'icDetalhar') this.openDetailModal(button, params)
    if (button.name === 'btGenerateOrder') this.openGenerateOrderModal(button, params)
  }

  async openGenerateOrderModal (button, params) {
    this.hasRowSelected()
    const forms = await repository.resolve('generatePreFixedBillingOrder.generatePreFixedBillingOrderModal')
    this.generateModal = {
      show: true,
      forms: forms,
      label: button.label,
      params: params
    }
  }

  hasRowSelected () {
    if (this.rowsSelected.length === 0) {
      messageBox.warn(this.$gettext('NO_ROW_SELECTED'))
      throw 'noItemsSelectedException'
    }
  }

  async generateOrders (button, params) {
    const { id: controlBatch } = this.orderState.actualBatchInfos
    for (const row of this.rowsSelected) {
      const requestObject = {
        ...params,
        ids: [],
        collectionPoints: [],
        clients: [],
        ...this.orderState.actualBatchInfos,
        controlBatch,
        contractBillingType: this.getContractBillingType()
      }
      const contractItemCollectionPoints = JSON.parse(row.contractItemCollectionPoints)
      const preFixedBillingOrders = JSON.parse(row.preFixedBillingOrders)
      requestObject.ids = requestObject.ids.concat(preFixedBillingOrders)
      requestObject.collectionPoints = requestObject.collectionPoints.concat(contractItemCollectionPoints)
      requestObject.clients.push(row?.client)
      await repository.resolveLogic('generatePreFixedBillingOrder.generateBillingOrder', requestObject)
    }
    this.generateModal.show = false
    this.$refs.table.refresh()
  }

  async openDetailModal (button, params) {
    const { preFixedBillingOrder, mainCollectionPoint, collectionPointId, collectionPoint } = params

    const forms = await this.fetchDetailForm(preFixedBillingOrder)
    const composition = await this.fetchDetailComposition(preFixedBillingOrder, mainCollectionPoint, collectionPointId)
    this.setDefaultQuantityToOne(composition)

    this.updateFormDetailWithComposition(forms[0].dadosForm, collectionPoint, composition.registros)

    this.detailModal = this.buildDetailModalData(forms, params)
  }

  // TODO: At the moment the quantity is not being used to calculate the total amount of the bill, but only to inform the user
  setDefaultQuantityToOne (composition) {
    composition.registros.forEach(e => { e.quantity = '1.0' })
  }

  async fetchDetailForm (preFixedBillingOrder) {
    return await repository.resolve('preFixedBillingOrder.detalhar', { id: preFixedBillingOrder })
  }

  async fetchDetailComposition (preFixedBillingOrder, mainCollectionPoint, collectionPointId) {
    const model = mainCollectionPoint ? 'preFixedBillingOrder.findItemsFromMainCollectionPoint' : 'preFixedBillingOrder.findItems'
    return await repository.resolveDatatableModel(model, {
      grid: 'findItemsComposition',
      id: preFixedBillingOrder,
      collectionPoint: collectionPointId,
      contractBillingType: this.getContractBillingType()
    })
  }

  getContractBillingType () {
    return this.searchType === 'fixed' ? this.filters.fixed.contractBillingType : this.filters.contractMaintenance.contractBillingType
  }

  updateFormDetailWithComposition (form, collectionPoint, items) {
    form.collectionPointName = collectionPoint
    form.items = items
  }

  buildDetailModalData (forms, params) {
    return {
      show: true,
      forms: forms,
      label: this.$gettext('VIEW_ORDER_INFORMATION'),
      params: params,
      detail: true
    }
  }
}
export default GeneratorFixedOrder
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';
.formatedValue {
  font-weight: 500;
}
.keep-grid-data-on-colapse{
  display: none;
}
/deep/ td span {
  text-wrap: auto !important;
}
</style>
